// The backend detail endpoints can return a slide's SlideOptions in an arbitrary
// order; the canonical display order lives in each option's numeric `order` field.
//
// Scoped intentionally narrow to POLL slide types (the reported bug, AHA poll/imageChoice)
// to keep the mutation-level normalisation's blast radius small — non-poll slides are left
// untouched here. The backend now also returns options pre-sorted for every type, so this
// is defense-in-depth for the poll case specifically.
const POLL_SLIDE_TYPES = ['multipleChoice', 'imageChoice']

const sortByOrder = (a, b) => a.order - b.order

// Sorts a poll slide's SlideOptions array in place by `order`. Non-poll slides are
// returned untouched.
export const sortSlideOptionsInPlace = (slide) => {
  if (!slide || !POLL_SLIDE_TYPES.includes(slide.type)) return slide
  if (!Array.isArray(slide.SlideOptions) || slide.SlideOptions.length < 2) return slide
  slide.SlideOptions.sort(sortByOrder)
  return slide
}

// Sorts the SlideOptions of every poll slide in a presentation-like payload, in place.
// Handles both the normalised `slides` key and the raw API `Slides` key.
export const sortPresentationSlideOptionsInPlace = (presentation) => {
  if (!presentation) return presentation;
  [presentation.slides, presentation.Slides].forEach((slides) => {
    if (Array.isArray(slides)) slides.forEach(sortSlideOptionsInPlace)
  })
  return presentation
}
